const isNotEmptyOrNull = (string) => Boolean(string);

export { isNotEmptyOrNull };
